import React, { Fragment } from 'react';
import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import logo from '../src/media/logo.png'
import image from '../src/media/file_img.png'

const styles = StyleSheet.create({
  page: {fontSize: 11,paddingTop: 20,paddingLeft: 40,paddingRight: 40,lineHeight: 1.5,flexDirection: 'column'},

  spaceBetween : {flex : 1,flexDirection: 'row',alignItems:'center',justifyContent:'space-between' },

  titleContainer: {flexDirection: 'row',marginTop: 24},

  motivationContainer: {marginTop: 75, alignItems: "center"},
  
  logo: { width: 150 },
  
  image: { width: 250 },

  reportTitle: {  fontSize: "20pt",  textAlign: 'center', color: "#479e35"},

  motivationTitle: {  fontSize: "16pt",  textAlign: 'center', color: "#127026"},
  
  info : {fontSize: "11pt"}, 

  businnesinfo : {fontSize: "9pt", opacity: 0.6}, 
        
  invoiceTitle : {opacity: 0.5,fontSize: "11pt"},
  
  invoiceNumber : {fontSize: "18pt", color: "#127026"}, 
  
  address : { fontWeight: 400, fontSize: 10},
  
  theader : {marginTop : 20,fontSize : 10,fontStyle: 'bold',paddingTop: 4 ,paddingLeft: 7 ,flex:1,height:20,backgroundColor : '#c2e8ba',borderColor : 'whitesmoke',borderRightWidth:1,borderBottomWidth:1},

  theader2 : { flex:2, borderRightWidth:0, borderBottomWidth:1},

  tbody:{ fontSize : 9, paddingTop: 4 , paddingLeft: 7 , flex:1, borderColor : 'whitesmoke', borderRightWidth:1, borderBottomWidth:1},

  total:{ fontSize : 9, paddingTop: 4 , paddingLeft: 7 , flex:1.5, borderColor : 'whitesmoke', borderBottomWidth:1},

  tbody2:{ flex:2, borderRightWidth:1, },

  toRight:{alignItems:"flex-end", paddingTop:10},

  smallInfo:{marginTop : 10, paddingLeft: 5, fontSize:8}
});

const InvoiceTitle = () => (
  <View style={styles.titleContainer}>
      <View style={styles.spaceBetween}>
          <Text style={styles.reportTitle}>Resultados Simulador</Text>
          <Image style={styles.logo} src={logo} />
      </View>
  </View>
);

const TableHead = () => (
  <View style={{ width:'100%', flexDirection :'row', marginTop:10}}>
      <View style={[styles.theader, styles.theader2]}>
          <Text >Descrição</Text>   
      </View>
      <View style={styles.theader}>
          <Text>Valor</Text>   
      </View>
  </View>
);

const Motivation = () => (
<View style={styles.motivationContainer}>
          <Text style={styles.motivationTitle}>Ajude-nos a construir um futuro melhor!</Text>
          <Image style={styles.image} src={image} />
      </View>
);

const ResultsDoc = (props) => (
    <Document id="print">
        <Page size="A4" style={styles.page}>
          <InvoiceTitle />
          <View style={styles.toRight}>
              <Text style={styles.businnesinfo}>wastewiseinnovations.github.io/web/#/</Text>
              <Text style={styles.businnesinfo}>wastewiseinnovations@gmail.com</Text>
          </View>
          <View style={styles.titleContainer}>
                <View style={styles.spaceBetween}>
                <View>
              <Text style={styles.invoiceTitle}>Dados Cliente</Text>
              <Text style={styles.info} >{props.fields.type}</Text>
              <Text style={styles.info}>{props.fields.name}</Text>
              <Text style={styles.info}>{props.fields.email}</Text>
              <Text style={styles.info}>+351 {props.fields.contact}</Text>
              <Text style={styles.info}>{props.fields.address}</Text>
          </View>
          <View>
              <Text style={styles.invoiceTitle}>Número de Tijolos</Text>
              <Text style={styles.invoiceNumber}>{props.fields.bricks}</Text>
          </View>
                </View>
            </View>
            <TableHead />
            <View style={{ width:'100%', flexDirection :'row'}}>
                    <View style={[styles.tbody, styles.tbody2]}>
                        <Text >Custo total dos tijolos*</Text>   
                    </View>
                    <View style={styles.tbody}>
                        <Text>{props.fields.cost} €</Text>   
                    </View>
                </View>
                <View style={{ width:'100%', flexDirection :'row'}}>
                <View style={[styles.tbody, styles.tbody2]}>
                        <Text >Custo de transporte*</Text>   
                    </View>
                    <View style={styles.tbody}>
                        <Text>2 €/km</Text>   
                    </View>
                </View>
                <View style={{ width:'100%', flexDirection :'row'}}>
                <View style={[styles.tbody, styles.tbody2]}>
                        <Text >Redução das emissões de CO2</Text>   
                    </View>
                    <View style={styles.tbody}>
                        <Text>{props.fields.emissions*1000} kg</Text>   
                    </View>
                </View>
                <Text style={styles.smallInfo}>*acresce IVA à taxa legal em vigor.</Text>   
                <Motivation />
        </Page>
    </Document>
);

export default ResultsDoc